import { create } from 'zustand';
import {
  defaultNotificationFilter,
  type NotificationFilter,
} from 'src/notifications/notificationFilters';

// The drawer opens from the bell (keeping whatever filter was last applied) and from the
// dashboard tiles (pre-filtered to the tile's group), so the open state and filter live in a
// store rather than in the bell's local state.
type State = {
  opened: boolean;
  filter: NotificationFilter;
  open: (filter?: NotificationFilter) => void;
  close: () => void;
  updateFilter: (updater: (current: NotificationFilter) => NotificationFilter) => void;
};

export const useNotificationDrawerStore = create<State>()(set => ({
  opened: false,
  filter: defaultNotificationFilter,
  open: filter => set(state => ({ opened: true, filter: filter ?? state.filter })),
  close: () => set({ opened: false }),
  updateFilter: updater => set(state => ({ filter: updater(state.filter) })),
}));
